/* eslint-disable react/prop-types */
import { Input as AntdInput } from 'antd';
import cn from 'clsx';
import React from 'react';
import classes from './Input.module.scss';

const AInput = ({ className = '', inputRef, fullWidth, radius, minHeight, isSearch, ...other }) => {
  return (
    <AntdInput
      {...other}
      className={cn(
        classes.wrapper,
        {
          [classes.fullWidth]: fullWidth,
          [classes.largeMinHeight]: minHeight && other.size === 'large',
          [classes.isSearch]: isSearch,
        },
        classes[`radius_${radius}`],
        className
      )}
      ref={inputRef}
    />
  );
};

export default AInput;
